document.addEventListener("DOMContentLoaded", function() {
    // Hide BinderPOS store credit link
    var binderPOSLink = document.querySelector('#binderpos-open-credit');
    if (binderPOSLink) {
        binderPOSLink.style.display = 'none';
    }

    // Hide BinderPOS banner on the far right
    var binderPOSBanner = document.querySelector('.binderPOS-banner');
    if (binderPOSBanner) {
        binderPOSBanner.style.display = 'none';
    }
});
